export default "<search-overlay class=\"search-overlay\">\n</search-overlay>";